import React, { useState } from 'react'
import { Col, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'

export default function MAndEWorkerForm({
  schema: _schema,
  isView,
  onDeleteWorker = () => {},
  onUpdateWorker = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isAdd, setIsAdd] = useState()
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(formSchema.values || [])
  const [addIndex, setSddIndex] = useState(1)

  const onSubmit = (data) => {
    // console.log('onSubmit:', data)

    let addDatas = [...datas]
    console.log(datas.find((e) => e.email == data.email))

    if (datas.find((e) => e.email == data.email)) {
      notification.open('error', {
        title: `อีเมล ${data.email} มีข้อมูลอยู่แล้ว`,
        duration: 5000,
      })
    } else {
      var prename = formSchema.preName?.options?.find((e) => e.value == data.preName)?.label

      addDatas.push({
        id: `NEW_${addIndex}`,
        preNameId: data.preName,
        preName: prename,
        firstName: data.firstName,
        lastName: data.lastName,
        fullName: `${prename}${data.firstName} ${data.lastName}`,
        email: data.email,
        phone: data.phone,
      })

      setSddIndex(addIndex + 1)
      setData(addDatas)
      onUpdateWorker(addDatas)
      onRefash()
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const onDelete = (data, index) => {
    if (!data.id?.startsWith('NEW')) {
      onDeleteWorker(data.id)
    }

    let addDatas = [...datas]
    addDatas.splice(index, 1)
    setData(addDatas)
    onUpdateWorker(addDatas)
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      {!isView && (
        <>
          {!isRefash && (
            <>
              {isAdd ? (
                <>
                  <Row style={{ marginTop: -10 }}>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <InputSelectForm
                        schema={formSchema.preName}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <InputForm
                        schema={formSchema.firstName}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <InputForm
                        schema={formSchema.lastName}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <InputForm
                        schema={formSchema.email}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <InputForm
                        schema={formSchema.phone}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: 10, textAlign: 'right' }}
                    >
                      <SaveButton icon="plus" children="เพิ่ม" onClick={handleSubmit(onSubmit)} />
                      <CancelButton
                        children="ยกเลิก"
                        onClick={() => {
                          setIsAdd(false)
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <Row style={{ marginTop: -10 }}>
                  <Col style={{ marginTop: 10 }}>
                    <SaveButton
                      icon="plus"
                      children="เพิ่ม"
                      onClick={() => {
                        setIsAdd(true)
                      }}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </>
      )}

      <Table
        wordWrap
        bordered
        autoHeight
        data={datas || []}
        // loading={loading}
      >
        <Column align="center" width={100} fixed>
          <HeaderCell>
            <span>ลำดับ</span>
          </HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column width={250} flexGrow={1}>
          <HeaderCell>
            <span>ชื่อ - สกุล</span>
          </HeaderCell>
          <Cell dataKey="fullName" />
        </Column>
        <Column width={200}>
          <HeaderCell>
            <span>อีเมล</span>
          </HeaderCell>
          <Cell dataKey="email" />
        </Column>
        <Column width={200}>
          <HeaderCell>
            <span>เบอร์ติดต่อ</span>
          </HeaderCell>
          <Cell dataKey="phone" />
        </Column>

        {/* <Column width={isView ? 150 : 250} fixed="right" align="center"> */}
        <Column width={150} fixed="right" align="center">
          <HeaderCell>
            <span>จัดการ</span>
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <>
                  {/* <ViewButton
                    style={{
                      marginRight: 10,
                      marginBottom: 10,
                    }}
                    children="แสดง"
                    onClick={() => {
                      // go to other page
                    }}
                  /> */}
                  {!isView && (
                    <CancelButton
                      icon="trash"
                      onClick={() => {
                        onDelete(rowData, index)
                      }}
                      children="ลบ"
                    />
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Panel>
  )
}
